import { useChainId } from '@lair-finance/wagmi'
import { ActiveChain } from '@/domains/chain'
import { WalletAssetListKaia } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/chains/WalletAssetListKaia.tsx'
import { WalletAssetListBera } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/chains/WalletAssetListBera.tsx'
import { WalletAssetListInjectiveTestnet } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/chains/WalletAssetListInjectiveTestnet.tsx'
import { WalletAssetListSomnia } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/chains/WalletAssetListSomnia.tsx'

export function WalletAsset({ className }: { className?: string }) {
  const chainId = useChainId()

  switch (chainId) {
    case ActiveChain.KAIA.id:
      return <WalletAssetListKaia className={className} />
    case ActiveChain.INJECTIVE.id:
      return <WalletAssetListInjectiveTestnet className={className} />
    case ActiveChain.SOMNIA.id:
      return <WalletAssetListSomnia className={className} />
    default:
      return <WalletAssetListBera className={className} />
  }
}
